import { Component, inject } from '@angular/core';
import { FooterFacade } from '@layout/footer/data-access/services/footer-facade';
import { ChangeLanguageDropdown } from '@layout/footer/ui/change-language-dropdown/change-language-dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { RichTextDirective } from '@shared/directives/rich-text/rich-text.directive';
import { HideTranslationPipe } from '@shared/pipes/hide-translation/hide-translation.pipe';
import { WYSIWYGPipe } from '@ui/pipes/wysiwyg.pipe';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [TranslateModule, HideTranslationPipe, WYSIWYGPipe, RichTextDirective, ChangeLanguageDropdown],
  providers: [FooterFacade]
})
export class FooterComponent {
  readonly #footerFacade = inject(FooterFacade);

  protected readonly footerState = this.#footerFacade.state;

  protected onChangeLanguage(language: string) {
    this.#footerFacade.changeLanguage(language);
  }
}
